import { createFileRoute } from '@tanstack/react-router'

import { DuplicatesPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/duplicates',
)({
  component: DuplicatesPage,
})
